import React, { useEffect, useRef } from "react";
import Close from "./icons/close";

const Modal = ({ isOpen, onClose, children }) => {
  const modalRef = useRef();

  // Close modal when clicking outside of it
  useEffect(() => {
    // If the modal is open, set up the event listener to detect clicks outside
    if (isOpen) {
      const handleOutsideClick = (e) => {
        if (modalRef.current && !modalRef.current.contains(e.target)) {
          onClose(); // Close modal if click is outside
        }
      };

      // Add event listener to document to detect outside click
      document.addEventListener("mousedown", handleOutsideClick);

      // Clean up event listener when the component is unmounted or modal is closed
      return () => {
        document.removeEventListener("mousedown", handleOutsideClick);
      };
    }
  }, [isOpen, onClose]);

  if (!isOpen) return null; // Don't render modal if it's not open

  return (
    <div className="fixed p-5 inset-0 z-50 flex items-center justify-center overflow-x-auto bg-black bg-opacity-50">
      <div
        ref={modalRef}
        className="p-1 md:p-4 bg-white rounded-lg shadow-lg w-fit max-w-[95%] relative"
      >
        <button
          onClick={onClose}
          aria-label="Close modal"
          className="absolute group text-green-2 flex justify-center items-center -top-3 -right-4 font-bold text-center text-2xl w-10 h-10 bg-white rounded-full transition duration-300 ease-in-out z-20"
        >
          <span>
            {" "}
            <Close className="w-10 group:hover:animate-spin group:hover:scale-110 group:hover:text-white" />
          </span>
        </button>
        <div className="overflow-x-auto overflow-y-auto">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
